export const model = {
    id: null,
    name: '',
    created_at: '',
    updated_at: '',
    pocket_treatments_price_limit: null,
    pocket_treatment:null,
};
